import styled from "styled-components";

export const RedireccionContainer = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  background-color: var(--color-latex30);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  padding: 10px 0;
  width: 100%;
`;

export const CruzContainer = styled.div`
  right: 20px;
  top: 10px;
  position: absolute;
  display: block;
  height: 16px;
  width: 16px;
  .line1 {
    border: 1px solid #fff;
    height: 20px;
    transform: rotate(45deg);
    width: 0px;
    background: #fff;
    position: absolute;
    left: 8px;
  }
  .line2 {
    border: 1px solid #fff;
    height: 20px;
    transform: rotate(-45deg);
    width: 0px;
    background: #fff;
    position: absolute;
    left: 8px;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const ButtonRedireccion = styled.div`
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;